var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10 7 7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 14-3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14 10 3-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14 14 3 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.205 4.139a4 4 0 1 1 5.439 5.863"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.637 14a4 4 0 1 1-5.432 5.868"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.367 10a4 4 0 1 1 5.438-5.862"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.795 19.862a4 4 0 1 1-5.429-5.873"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 4,
    height: 8,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrone);
export default __webpack_public_path__ + "static/media/drone.c6a501b2673bee494b40f8c97e47cba3.svg";
export { ForwardRef as ReactComponent };